import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9hebqmabw: FaireBrandEntity = {
  token: "b_a9hebqmabw",
  type: "brand",
  name: "ABLNco",
  avatarUrl:
    "https://cdn.faire.com/fastly/c45b85a2e5505ef5e62a4f0d3f60489980c28d756d02571ce487316366fed716.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/128e4e8508d6dc8c81865af8da178360f9fecd51b8bb9d7e77b5154a93353f7d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c45b85a2e5505ef5e62a4f0d3f60489980c28d756d02571ce487316366fed716.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/128e4e8508d6dc8c81865af8da178360f9fecd51b8bb9d7e77b5154a93353f7d.jpeg",
  location: "Palmyra , PA, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 320,
  isTopShop: true,
  isInsider: true,
  description:
    "CURRENT TAT 5 days \n\n•No rush shipping available on faire. Please place orders according to our turnaround time\n\nABLN Boutique is here to provide you with the next custom trend! Our shop specializes in patchwork and we can't wait to show you the beauty of our work! Our products are authentic and unique, and our ideas and photos all come from a super small business owner\n•\n•\nTHANK YOU for your Support & Trust",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.218Z",
    importedBy: "entity-db-cli",
  },
};
